import { render, staticRenderFns } from "./LogoutActivity.vue?vue&type=template&id=2e86b542"
import script from "./LogoutActivity.vue?vue&type=script&lang=js"
export * from "./LogoutActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports